<section *ngIf="!projectId">
  <nz-skeleton [nzActive]="true"
               [nzLoading]="!projectId"
               [nzTitle]="false"
               [nzParagraph]="{ rows: 2 }">
  </nz-skeleton>
</section>
<rappider-title-toolbar *ngIf="projectId"
                        [mainTitle]="mainTitle"
                        [options]="title"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton">
</rappider-title-toolbar>
<section>
  <rappider-list-grid [config]="UI_DATA_STORE_LIST_CONFIG"
                      [data]="uiDataStores"
                      [loading]="isLoading"
                      (columnActionClick)="onUIDataStoreDelete($event)"
                      (listActionClick)="onUIDataStoreRefresh($event)"></rappider-list-grid>
</section>
